import React from "react";
import { Field } from "formik";
import ScrollArrow from "components/util/helpers/ScrollArrow";
import IsometricImage from "components/util/helpers/icons/IsometricImage";
import l from "components/util/l";

const RevisionSections = ({
  tabs,
  sectionAnnotations,
  activeTabIdx,
  activeSectionIdx,
  currentTab,
  currentAnnotations,
  annotationNumbers,
  approvalLabel,
  showMockups,
  allowComments,
  currentAuthor,
  isDeveloper,
  TextAnnotator,
  onClickSelectTab,
  onChangeCurrentAnnotations
}) => {
  const attachments = currentTab.attachments || [];

  return (
    <div className={"revision-section h-100 pb-4 pb-md-0 px-0 px-md-2  " +
      (showMockups ? "col-md-4" : "col-md-6")}
      style={!showMockups ? { maxWidth: "40rem" } : {}}>
      <div className="p-0 h-100 rounded bg-white overflow-auto">
        <div className="position-absolute w-100 overflow-hidden"
          style={{ bottom: "0", left: "0", pointerEvents: "none" }}>
          <IsometricImage />
        </div>

        {tabs.length > 1 &&
          <div className="px-3 py-2 border-bottom">
            <ScrollArrow
              scrollAmount={250}>
              <div className="d-flex w-100 align-items-right">
                {tabs.map((tab, index) => {
                  const sourceIndex = tab.sourceIndex ?? index;
                  const tabLabel = tab.name || `Pestaña ${index + 1}`;
                  const type = tab.type;
                  return (
                    <button key={sourceIndex} type="button"
                      className={"btn btn-sm py-2 mr-1 " +
                        (activeTabIdx === sourceIndex ? "text-primary font-weight-bold " : "text-secondary ")}
                      onClick={() => onClickSelectTab(sourceIndex)}
                      style={{
                        borderBottom: activeTabIdx === sourceIndex ? "1px solid #2080e5" : "1px solid transparent",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {type == "dev" && <i className="fas fa-code mr-1"></i>}
                      {tabLabel}
                    </button>
                  );
                })}
              </div>
            </ScrollArrow>
          </div>
        }

        <div className="p-4" style={{ paddingBottom: "24px" }}>
          <div style={{ paddingBottom: "16px" }}>

            <div className="content-container">
              <div
                key={(currentTab.content || "").substring(0, 20)}
                className="text-annotator-wrapper position-relative animate__animated animate__fadeIn"
                style={{ paddingBottom: "24px", marginBottom: "16px" }}>
                <TextAnnotator
                  html={currentTab.content || ""}
                  annotations={currentAnnotations}
                  annotationNumbers={annotationNumbers}
                  onChange={onChangeCurrentAnnotations}
                  isEditable={allowComments}
                  currentAuthor={currentAuthor}
                  defaultAnnotationData={{
                    visibility_scope: isDeveloper ? "DEV" : "CLIENT",
                    is_solved: false,
                  }}
                />

                {attachments.length > 0 && (
                  <div className="mt-3 mb-4">
                    <h6 className="small text-muted font-weight-bold text-uppercase mb-2">
                      {l("Archivos adjuntos%AB096")}
                    </h6>

                    {attachments.map((attachment, index) => {
                      return (
                        <div
                          key={`${attachment.id || attachment.name || "attachment"}-${index}`}
                          className="d-flex align-items-center mb-2"
                          style={{ gap: "0.5rem" }}
                        >
                          <i className="fas fa-paperclip text-muted"></i>
                          <a
                            href={attachment.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary text-truncate"
                            style={{ maxWidth: "85%" }}
                          >
                            {attachment?.name.split("_").slice(1).join("_")}
                          </a>
                        </div>
                      );
                    })}
                  </div>
                )}
{allowComments && (
                  <div className="position-absolute w-100 d-flex justify-content-end align-items-center">
                    <div className="d-flex flex-column justify-content-end">
                      <label className="d-flex align-items-center mb-2">
                        <Field name={`confirmation-${activeSectionIdx}`} type="checkbox" className="mr-2" required />
                        <span className="small text-muted">
                          {approvalLabel}
                        </span>
                      </label>
                      <button type="submit" className="btn btn-sm btn-primary">
                        {l("Siguiente%GA039")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RevisionSections;
